import { clsx } from "clsx";

import { Border } from "~/components/border";
import { FadeIn, FadeInStagger } from "~/components/fade-in";

export function GridList({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <FadeInStagger>
      <ul
        className={clsx(
          "grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-3",
          className,
        )}
      >
        {children}
      </ul>
    </FadeInStagger>
  );
}

export function GridListItem({
  title,
  children,
  className,
}: {
  title: string;
  children?: React.ReactNode;
  className?: string;
}) {
  return (
    <li className={clsx("text-base text-ink-300", className)}>
      <FadeIn>
        <Border position="left" className="pl-8">
          <strong className="font-semibold text-ink-50">{title}.</strong>{" "}
          {children}
        </Border>
      </FadeIn>
    </li>
  );
}
